import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-screen" }
const _hoisted_2 = { class: "flex flex-grow flex-1 bg-stone-500" }
const _hoisted_3 = {
  class: "bg-stone-900 text-neutral-200 p-2 text-sm space-x-16 flex items-center",
  id: "footer"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { id: "modal-root" }, null, -1)

import {computed, inject} from "vue";
import {useRoute, useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const version = inject('version')

const router = useRouter();
const route = useRoute();

const canLogout = computed(() => {
  return route.meta?.requiresAuth;
});

const logout = () => {
  sessionStorage.removeItem('token');
  router.push({name: 'login'});
}

const requestFullscreen = () => {
  document.documentElement.requestFullscreen();
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("main", _hoisted_2, [
        _createVNode(_component_router_view)
      ]),
      _createElementVNode("footer", _hoisted_3, [
        _createElementVNode("span", null, "Version: " + _toDisplayString(_unref(version)), 1),
        _createElementVNode("a", {
          class: "cursor-pointer",
          href: "#",
          onClick: _withModifiers(requestFullscreen, ["prevent"])
        }, "Vollbild"),
        (canLogout.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "cursor-pointer",
              href: "#",
              onClick: _withModifiers(logout, ["prevent"])
            }, "Abmelden"))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_4
  ], 64))
}
}

})